import { Moment } from 'moment';
import { ChatGroupId } from '@/chat/models/ChatGroup';
import { WorkshopTeamId } from '@/general/models/WorkshopTeam';
import QualityControlStatus from '@/shared/constants/QualityControlStatus';
import { OutletId } from '@/shared/models/Outlet';
import Tag from '@/shared/models/Tag';
import { UserId } from '@/shared/models/User';
import WorkPreparationStatus from '@/workPreparation/constants/WorkPreparationStatus';
import CleaningMethod from '../constants/CleaningMethod';
import CleaningStatus from '../constants/CleaningStatus';
import KeyBoxStatus from '../constants/KeyBoxStatus';
import MechanicPausedStatus from '../constants/MechanicPausedStatus';
import PartsOrderStatus from '../constants/PartsOrderStatus';
import PaymentStatus from '../constants/PaymentStatus';
import PickingStatus from '../constants/PickingStatus';
import VehicleStatus from '../constants/VehicleStatus';
import WarrantyStatus from '../constants/WarrantyStatus';
import WorkStatus, { READY_WORK_STATUSES } from '../constants/WorkStatus';

export interface DossierId {__dossierId: number}

export type DossierReference = string;

export interface CleaningData {
  exteriorStatus: CleaningStatus | null;
  interiorStatus?: CleaningStatus | null;
  exteriorMethod?: CleaningMethod | null;
}

export default abstract class AbstractDossier {
  id!: DossierId;
  outletId!: OutletId;
  workshopTeamId: WorkshopTeamId | null = null;
  externalReference: DossierReference | null = null;
  vehicleStatus: VehicleStatus | null = null;
  workStatus: WorkStatus | null = null;
  workPreparationStatus: WorkPreparationStatus | null = null;
  partsOrderStatus: PartsOrderStatus | null = null;
  partsPickingStatus: PickingStatus | null = null;
  warrantyStatus: WarrantyStatus | null = null;
  keyBoxStatus: KeyBoxStatus | null = null;
  paymentStatus: PaymentStatus | null = null;
  workOnHoldReason: Tag | null = null;
  waitsOnPremise = false;
  appointmentOn: Moment | null = null;
  checkedInAt: Moment | null = null;
  preferredPickUpOn: Moment | null = null;
  assignedUserId: UserId | null = null;
  assignedGroupId: ChatGroupId | null = null;
  qualityControlStatus: QualityControlStatus | null = null;
  exteriorCleaningStatus: CleaningStatus | null = null;
  exteriorCleaningMethod: CleaningMethod | null = null;
  interiorCleaningStatus: CleaningStatus | null = null;
  mechanicPausedStatus = MechanicPausedStatus.NOT_APPLICABLE;
  isInvoiced = false;
  tags: Array<Tag> = [];

  isFinished(): boolean {
    return this.workStatus !== null && READY_WORK_STATUSES.includes(this.workStatus) && this.vehicleStatus === VehicleStatus.PICKED_UP;
  }

  hasCleaning(): boolean {
    return [this.interiorCleaningStatus, this.exteriorCleaningStatus].some(status => status !== null);
  }

  updateCleaning(data: CleaningData): void {
    this.exteriorCleaningStatus = data.exteriorStatus;
    this.exteriorCleaningMethod = data.exteriorMethod ?? null;
    this.interiorCleaningStatus = data.interiorStatus ?? null;
  }
}
